import React from 'react';
import Server from '../../../functions/server';
import Invoice from './invoice';
import Machineorder from './machineorder';
import $ from "jquery";
import { Grid, Button, Dropdown, Input } from 'semantic-ui-react';
import Checkbox from '@material-ui/core/Checkbox';
import Multifile from './multifile';
import Buttons from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import Status from './status';

class Title extends React.Component {

  state = {
    open: false,   machine: 'ALL', status: 'ALL', open1: false
  }

  generateQuotation = (id) => {
    let open = Server() + "pdf/mechinepurchasequotation.php?orderId="+id;
    window.open(open);
  }

  openPDF(invoice) { window.open(invoice); }

  getToday() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if( dd < 10){ dd = '0' + dd; }
    if(mm < 10) { mm = '0' + mm; }
    today = yyyy+'-'+mm+'-'+dd;
    return today;
  }

  uploadpdf(file, id) {
    let context = this;
    let invoiceDate = this.getToday();
    var formData = new FormData();
    formData.append('id', id);
    formData.append('file', file);
    formData.append('invoice_date', invoiceDate);
    $.ajax({
      type: 'POST', processData: false,
      contentType: false, data: formData,
      url: Server() + 'machinesales/uploadinvoiceimage.php',
      success: function(data) {
        console.log(data);
        if (data == 1) { context.props.getorder(1); }
        else { alert('PDF not upload'); }
      },
      error: function(err) {
        context.setState({ error: "Try again" });
      }
    });
  }

  machineDetails(data, option) {
    option.push({ key: 'ALL', text: 'ALL', value: 'ALL' })
    this.setState({ data: data, machineOption: option })
  }

  statesChnage = (f, { value }) => { this.setState({ machine: value, status: 'ALL' }); }

  statesChnage1 = (f, { value }) => { this.setState({ status: value }); }

  handleChange = name => event => { this.setState({ [name]: event.target.checked }); };

  onChangeText = (type) => (f, { value }) => { this.setState({ [type]: value }); }

  upload (val) { document.getElementById('fileToUpload'+val).click(); }

  

  submit() {
    let context = this;
    let id = this.state.referenceId;
    let referenceNo = this.state.referenceNo;
    $.ajax({
      type: 'POST',
      data: { 'id': id, 'referenceNo': referenceNo },
      url: Server() + 'machinesales/uploadreferencenumber.php',
      success: function(data)
      {
        if (data == 1) {
          context.setState({ dialogOpen: false });
          let data = context.props.data;
          data.map((c) => {
            if (c.id == id) { c.reference_no = referenceNo; }
          })
          context.props.update(data);
        }
        else { alert('Try again!!!'); }
      },
      error: function(err) {
        context.setState({ error: "Try again" });
      }
    });
  }

  openDmsValueDialog(item) {
    this.setState({ 
      openDmsValueDialog: true, 
      dmsId: item.id, 
      dmsValue: item.dms_value, 
      dmsInvoiceDate: item.dms_invoice_date, 
      dmsInvoiceNumber: item.dms_invoice_no 
    })
  }

  handleChangedate = name => event => {
    this.setState({
      dmsInvoiceDate: event.target.value,
    });
  }

  submitDmsValues() {
    let context = this;
    let { dmsId, dmsValue, dmsInvoiceDate, dmsInvoiceNumber } = this.state;
    let data = { dmsId, dmsValue, dmsInvoiceDate, dmsInvoiceNumber };
    $.ajax({
      type: 'POST', data,
      url: Server() + 'machinesales/UpdateDmsValue.php',
      success: function(data) {
        if (data == 1) {
          context.setState({ openDmsValueDialog: false });
          let data = context.props.data;
          data.map((c) => {
            if (c.id == dmsId) { 
              c.dms_invoice_no = dmsInvoiceNumber; 
              c.dms_invoice_date = dmsInvoiceDate; 
              c.dms_value = dmsValue; }
          })
          context.props.update(data);
        }
        else { alert('Try again!!!'); context.setState({ openDmsValueDialog: false }); }
      },
      error: function(err) {
        alert("Try again");
        context.setState({ openDmsValueDialog: false });
      }
    });
  }

  render() {
    let i = 0;
    let menu = [
      { key: 'Open', text: 'Open', value: 'Open' },
      { key: 'Processing', text: 'Processing', value: 'Processing' },
      { key: 'Success', text: 'Success', value: 'Success' },
      { key: 'Fail', text: 'Fail', value: 'Fail' },
      { key: 'ALL', text: 'ALL', value: 'ALL' },
    ];
    return (
      <div>
        <Dialog fullWidth={this.state.fullWidth}  maxWidth={this.state.maxWidth}
          open={this.state.openDmsValueDialog} onClose={ () => { this.setState({ openDmsValueDialog: false }) } } aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">DMS VALUES UPDATE</DialogTitle>
          <DialogContent>
            Dms Invoice Number<br/>
            <Input value={this.state.dmsInvoiceNumber} onChange={this.onChangeText('dmsInvoiceNumber')} style={{width: '100%'}} />
            Dms Invoice Date<br/>
            <input type="date" id="date" value={this.state.dmsInvoiceDate}
                          style={{width: '100%', height: 35 }} onChange={this.handleChangedate('dmsInvoiceDate')} />
            Dms Value<br/>
            <Input value={this.state.dmsValue} onChange={this.onChangeText('dmsValue')} style={{width: '100%'}} />
          </DialogContent>
          <DialogActions>
            <Button color="primary" onClick={this.submitDmsValues.bind(this)}>Submit</Button>
            <Button color="primary" onClick={ () => { this.setState({ openDmsValueDialog: false }) } }>Close</Button>
          </DialogActions>
        </Dialog>
      <Grid>
        { this.props.menuPermission.add && this.props.type != 'Invoice' ?
          <Grid.Column mobile={16} tablet={16} computer={2}>
            <Machineorder type='add' machineDetails={this.machineDetails.bind(this)}
              getorder={this.props.getorder} machinesalesedit={this.props.machinesalesedit} />
          </Grid.Column>:null
        }
        
        {/* <Grid.Column mobile={16} tablet={16} computer={4}>
          <Dropdown placeholder='State' style={{ borderColor: '#5A9CBB' }}
           fluid search selection onChange={this.statesChnage} fluid
           options={this.state.machineOption} value={this.state.machine} />
        </Grid.Column>
        <Grid.Column mobile={16} tablet={16} computer={4}>
          { this.props.type == 'Invoice' ?
            (<div></div>) :
            (<Dropdown placeholder='State' style={{ borderColor: '#5A9CBB' }}
               fluid search selection onChange={this.statesChnage1} fluid
               options={menu} value={this.state.status} />)
          }
        </Grid.Column> */}
        <Grid.Column mobile={16} tablet={16} computer={16}>
        <div id='scrolls'>
          { this.props.type == 'Quotation' ?
            (
              <table id='table' width="100%">
                <tr>
                  <th id='tableheader'><center>Sino</center></th>
                  <th id='tableheader' style={{ width: '5%' }}><center>Id</center></th>
                  <th id='tableheader'><center>Machine</center></th>
                  <th id='tableheader'><center>Customer</center></th>
                  <th id='tableheader'><center>Delivary Date</center></th>
                  <th id='tableheader'><center>Followup Date</center></th>
                  <th id='tableheader'><center>Remarks</center></th>
                  <th id='tableheader'><center>Quotation</center></th>
                  { this.props.menuPermission.edit ?
                    <th id='tableheader'><center>Invoice</center></th>:''
                  }
                  { this.props.menuPermission.edit ?
                    <th id='tableheader'><center>Status</center></th>:''
                  }
                  { this.props.menuPermission.edit ?
                    <th id='tableheader'><center>Upload Invoice</center></th>:''
                  }
                  { this.props.menuPermission.edit ?
                    <th id='tableheader'><center>Edit</center></th>:''
                  }
                </tr>

                { this.props.data.map((x) => {
                    if (x.invoice == 0 || x.invoice == '0') {
                      if (this.state.machine == x.machine_id) {
                        if (this.state.status == x.status) {
                          i++;
                          return (
                            <tbody>
                              <tr>
                                <td><center>{i}</center></td>
                                <td><center>{x.id}</center></td>
                                <td><div>{x.machine_id+'->'+x.machine_name}</div></td>
                                <td><div>{x.customer_id+'->'+x.customer_name}</div></td>
                                <td><center>{x.expected_delivary}</center></td>
                                <td><center>{x.followup_date}</center></td>
                                <td><center>{x.remarks}</center></td>
                                <td onClick={this.generateQuotation.bind(this, x.id)}>
                                  <center>Generate</center>
                                </td>

                                { this.props.menuPermission.edit ?
                                  <td onClick={ () => { this.setState({ open: true }) }}>
                                    <center><Invoice id={x.id} data={this.props.data} /></center>
                                  </td>:''
                                }

                                { this.props.menuPermission.edit ?
                                  <td>
                                    <center>
                                      <Status getorder={this.props.getorder} status={x.status} id={x.id} />
                                    </center>
                                  </td>:''
                                }

                                { this.props.menuPermission.edit ?
                                  <td>
                                    <div>
                                      <input onChange={(e) => { this.uploadpdf(e.target.files[0], x.id) }}
                                            id={"fileToUpload"+x.id} name="fileToUpload" type="file"
                                        
                                      style={{display: 'none'}} />
                                      <Button color='blue' onClick={this.upload.bind(this, x.id)} id={x.id} fluid
                                          variant="outlined" component="span">
                                        Upload
                                      </Button>
                                    </div>
                                  </td>:''
                                }

                                { this.props.menuPermission.edit ?
                                  <td style={{display: this.props.machinesalesedit}}>
                                    <center>
                                      <Machineorder getorder={this.props.getorder}
                                          customer={this.props.customer} type='edit'
                                          data={this.props.data} id={x.id} />
                                    </center>
                                  </td>:''
                                }

                              </tr>
                            </tbody>
                          )
                        }
                        else if (this.state.status == 'ALL') {
                          i++;
                          return (
                            <tbody>
                              <tr>
                                <td><center>{i}</center></td>
                                <td><center>{x.id}</center></td>
                                <td><div>{x.machine_id+'->'+x.machine_name}</div></td>
                                <td><div>{x.customer_id+'->'+x.customer_name}</div></td>
                                <td><center>{x.expected_delivary}</center></td>
                                <td><center>{x.followup_date}</center></td>
                                <td><center>{x.remarks}</center></td>
                                <td onClick={this.generateQuotation.bind(this, x.id)}>
                                  <center>Generate</center>
                                </td>
                                { this.props.menuPermission.edit ?
                                  <td onClick={ () => { this.setState({ open: true }) }}>
                                    <center><Invoice id={x.id} data={this.props.data} /></center>
                                  </td>:''
                                }

                                { this.props.menuPermission.edit ?
                                  <td>
                                    <center>
                                      <Status getorder={this.props.getorder} status={x.status} id={x.id} />
                                    </center>
                                  </td>:''
                                }

                                { this.props.menuPermission.edit ?
                                  <td>
                                    <div>
                                      <input onChange={(e) => { this.uploadpdf(e.target.files[0], x.id) }}
                                            id={"fileToUpload"+x.id} name="fileToUpload" type="file"
                                      style={{display: 'none'}} />
                                      <Button color='blue' onClick={this.upload.bind(this, x.id)} id={x.id} fluid
                                          variant="outlined" component="span">
                                        Upload
                                      </Button>
                                    </div>
                                  </td>:''
                                }

                                { this.props.menuPermission.edit ?
                                  <td style={{display: this.props.machinesalesedit}}>
                                    <center>
                                      <Machineorder getorder={this.props.getorder}
                                          customer={this.props.customer} type='edit'
                                          data={this.props.data} id={x.id} />
                                    </center>
                                  </td>:''
                                }
                              </tr>
                            </tbody>
                          )
                        }
                      }
                      else if (this.state.machine == 'ALL') {
                        if (this.state.status == x.status) {
                          i++;
                          return (
                            <tbody>
                              <tr>
                                <td><center>{i}</center></td>
                                <td><center>{x.id}</center></td>
                                <td><div>{x.machine_id+'->'+x.machine_name}</div></td>
                                <td><div>{x.customer_id+'->'+x.customer_name}</div></td>
                                <td><center>{x.expected_delivary}</center></td>
                                <td><center>{x.followup_date}</center></td>
                                <td><center>{x.remarks}</center></td>
                                <td onClick={this.generateQuotation.bind(this, x.id)}>
                                  <center>Generate</center>
                                </td>
                                { this.props.menuPermission.edit ?
                                  <td onClick={ () => { this.setState({ open: true }) }}>
                                    <center><Invoice id={x.id} data={this.props.data} /></center>
                                  </td>:''
                                }

                                { this.props.menuPermission.edit ?
                                  <td>
                                    <center>
                                      <Status getorder={this.props.getorder} status={x.status} id={x.id} />
                                    </center>
                                  </td>:''
                                }

                                { this.props.menuPermission.edit ?
                                  <td>
                                    <div>
                                      <input onChange={(e) => { this.uploadpdf(e.target.files[0], x.id) }}
                                            id={"fileToUpload"+x.id} name="fileToUpload" type="file"
                                      style={{display: 'none'}} />
                                      <Button color='blue' onClick={this.upload.bind(this, x.id)} id={x.id} fluid
                                          variant="outlined" component="span">
                                        Upload
                                      </Button>
                                    </div>
                                  </td>:''
                                }

                                { this.props.menuPermission.edit ?
                                  <td style={{display: this.props.machinesalesedit}}>
                                    <center>
                                      <Machineorder getorder={this.props.getorder}
                                          customer={this.props.customer} type='edit'
                                          data={this.props.data} id={x.id} />
                                    </center>
                                  </td>:''
                                }
                              </tr>
                            </tbody>
                          )
                        }
                        else if (this.state.status == 'ALL') {
                          i++;
                          return (
                            <tbody>
                              <tr>
                                <td><center>{i}</center></td>
                                <td><center>{x.id}</center></td>
                                <td><div>{x.machine_id+'->'+x.machine_name}</div></td>
                                <td><div>{x.customer_id+'->'+x.customer_name}</div></td>
                                <td><center>{x.expected_delivary}</center></td>
                                <td><center>{x.followup_date}</center></td>
                                <td><center>{x.remarks}</center></td>
                                <td onClick={this.generateQuotation.bind(this, x.id)}>
                                  <center>Generate</center>
                                </td>
                                { this.props.menuPermission.edit ?
                                  <td onClick={ () => { this.setState({ open: true }) }}>
                                    <center><Invoice id={x.id} data={this.props.data} /></center>
                                  </td>:''
                                }

                                { this.props.menuPermission.edit ?
                                  <td>
                                    <center>
                                      <Status getorder={this.props.getorder} status={x.status} id={x.id} />
                                    </center>
                                  </td>:''
                                }

                                { this.props.menuPermission.edit ?
                                  <td>
                                    <div>
                                      <input onChange={(e) => { this.uploadpdf(e.target.files[0], x.id) }}
                                            id={"fileToUpload"+x.id} name="fileToUpload" type="file"
                                      style={{display: 'none'}} />
                                      <Button color='blue' onClick={this.upload.bind(this, x.id)} id={x.id} fluid
                                          variant="outlined" component="span">
                                        Upload
                                      </Button>
                                    </div>
                                  </td>:''
                                }

                                { this.props.menuPermission.edit ?
                                  <td style={{display: this.props.machinesalesedit}}>
                                    <center>
                                      <Machineorder getorder={this.props.getorder}
                                          customer={this.props.customer} type='edit'
                                          data={this.props.data} id={x.id} />
                                    </center>
                                  </td>:''
                                }
                              </tr>
                            </tbody>
                          )
                        }
                      }
                    }
                  })
                }
              </table>
            ) :
            (
              <table id='table' width="100%">
                <tr>
                  <th id='tableheader' style={{width: '3%'}}><center>Sino</center></th>
                  <th id='tableheader'><center>Invoice No</center></th>
                  <th id='tableheader'><center>Invoice Date</center></th>
                  <th id='tableheader'><center>Machine No</center></th>
                  <th id='tableheader'><center>Machine</center></th>
                  <th id='tableheader'><center>Customer</center></th>
                  <th id='tableheader'><center>DMS Invoice No</center></th>
                  <th id='tableheader'><center>DMS Invoice Date</center></th>
                  <th id='tableheader'><center>DMS Invoice Value</center></th>
                  <th id='tableheader'><center>Remarks</center></th>
                  <th id='tableheader' style={{display: this.props.machinesalesedit}}><center>Reference No</center></th>
                  <th id='tableheader' style={{display: this.props.machinesalesedit}}><center>File</center></th>
                </tr>
                { this.props.data.map((x) => {
                    if (x.invoice != 0 || x.invoice != '0') {
                    if (this.state.machine == x.machine_id) {
                      if (this.state.status == x.status) {
                        i++;
                        return (
                          <tbody>
                            <tr>
                              <td><center>{i}</center></td>
                              <td><center>{x.id}</center></td>
                              <td><center>{x.invoice_date}</center></td>
                              <td><center>{x.machine_no}</center></td>
                              <td><div>{x.machine_id+'->'+x.machine_name}</div></td>
                              <td><div>{x.customer_id+'->'+x.customer_name+'('+x.customer_taluk+')'}</div></td>
                              <td onClick={this.openDmsValueDialog.bind(this, x)}>{x.dms_invoice_no}</td>
                              <td onClick={this.openDmsValueDialog.bind(this, x)}>{x.dms_invoice_date}</td>
                              <td onClick={this.openDmsValueDialog.bind(this, x)}>{x.dms_value}</td>
                              <td id='pointer' onClick={ () => { this.setState({ remarkDialog: true, remarks: x.remarks }) }}><center>{'View'}</center></td>
                              <td id='pointer' style={{display: this.props.machinesalesedit}}
                                  onClick={
                                  () => { this.setState({ dialogOpen: true, referenceNo: x.reference_no,
                                                                    referenceId: x.id }) } }>
                                  <center>{x.reference_no}</center></td>
                              <td style={{display: this.props.machinesalesedit}}><center><Multifile id={x.id} invoiceno={x.invoice} machinesalesedit={this.props.machinesalesedit} /></center></td>
                            </tr>
                          </tbody>
                        )
                      }
                      else if (this.state.status == 'ALL') {
                        i++;
                        return (
                          <tbody>
                            <tr>
                              <td><center>{i}</center></td>
                              <td><center>{x.id}</center></td>
                              <td><center>{x.invoice_date}</center></td>
                              <td><center>{x.machine_no}</center></td>
                              <td><div>{x.machine_id+'->'+x.machine_name}</div></td>
                              <td><div>{x.customer_id+'->'+x.customer_name+'('+x.customer_taluk+')'}</div></td>
                              <td onClick={this.openDmsValueDialog.bind(this, x)}>{x.dms_invoice_no}</td>
                              <td onClick={this.openDmsValueDialog.bind(this, x)}>{x.dms_invoice_date}</td>
                              <td onClick={this.openDmsValueDialog.bind(this, x)}>{x.dms_value}</td>
                              <td id='pointer' onClick={ () => { this.setState({ remarkDialog: true, remarks: x.remarks }) }}><center>{'View'}</center></td>
                              <td id='pointer' style={{display: this.props.machinesalesedit}}
                              onClick={
                              () => {
                                this.setState({ dialogOpen: true, referenceNo: x.reference_no, referenceId: x.id }) }}>
                              <center>{x.reference_no}</center></td>
                              <td style={{display: this.props.machinesalesedit}}><center><Multifile id={x.id} invoiceno={x.invoice} machinesalesedit={this.props.machinesalesedit} /></center></td>
                            </tr>
                          </tbody>
                        )
                      }
                    }
                    else if (this.state.machine == 'ALL') {
                      if (this.state.status == x.status) {
                        i++;
                        return (
                          <tbody>
                            <tr>
                              <td><center>{i}</center></td>
                              <td><center>{x.id}</center></td>
                              <td><center>{x.invoice_date}</center></td>
                              <td><center>{x.machine_no}</center></td>
                              <td><div>{x.machine_id+'->'+x.machine_name}</div></td>
                              <td><div>{x.customer_id+'->'+x.customer_name+'('+x.customer_taluk+')'}</div></td>
                              <td onClick={this.openDmsValueDialog.bind(this, x)}>{x.dms_invoice_no}</td>
                              <td onClick={this.openDmsValueDialog.bind(this, x)}>{x.dms_invoice_date}</td>
                              <td onClick={this.openDmsValueDialog.bind(this, x)}>{x.dms_value}</td>
                              <td id='pointer' onClick={ () => { this.setState({ remarkDialog: true, remarks: x.remarks }) }}><center>{'View'}</center></td>
                              <td style={{display: this.props.machinesalesedit}} id='pointer' onClick={ () => { this.setState({ dialogOpen: true, referenceNo: x.reference_no, referenceId: x.id }) }}><center>{x.reference_no}</center></td>
                              <td style={{display: this.props.machinesalesedit}}><center><Multifile id={x.id} invoiceno={x.invoice} machinesalesedit={this.props.machinesalesedit} /></center></td>
                            </tr>
                          </tbody>
                        )
                      }
                      else if (this.state.status == 'ALL') {
                        i++;
                        return (
                          <tbody>
                            <tr>
                              <td><center>{i}</center></td>
                              <td><center>{x.id}</center></td>
                              <td><center>{x.invoice_date}</center></td>
                              <td><center>{x.machine_no}</center></td>
                              <td><div>{x.machine_id+'->'+x.machine_name}</div></td>
                              <td><div>{x.customer_id+'->'+x.customer_name+'('+x.customer_taluk+')'}</div></td>
                              <td onClick={this.openDmsValueDialog.bind(this, x)}>{x.dms_invoice_no}</td>
                              <td onClick={this.openDmsValueDialog.bind(this, x)}>{x.dms_invoice_date}</td>
                              <td onClick={this.openDmsValueDialog.bind(this, x)}>{x.dms_value}</td>
                              <td id='pointer' onClick={ () => { this.setState({ remarkDialog: true, remarks: x.remarks }) }}><center>{'View'}</center></td>
                              <td style={{display: this.props.machinesalesedit}} id='pointer' onClick={ () => { this.setState({ dialogOpen: true, referenceNo: x.reference_no, referenceId: x.id }) }}><center>{x.reference_no}</center></td>
                              <td style={{display: this.props.machinesalesedit}}><center><Multifile id={x.id} invoiceno={x.invoice} machinesalesedit={this.props.machinesalesedit} /></center></td>
                            </tr>
                          </tbody>
                        )
                      }
                    }
                  }
                  })
                }
              </table>
            )
          }
        </div>
        </Grid.Column>
      </Grid>

      <Dialog fullWidth={this.state.fullWidth}  maxWidth={this.state.maxWidth}
        open={this.state.dialogOpen} onClose={ () => { this.setState({ dialogOpen: false }) } } aria-labelledby="max-width-dialog-title">
        <DialogTitle id="max-width-dialog-title">Reference Number</DialogTitle>
        <DialogContent>
          <Input value={this.state.referenceNo} onChange={this.onChangeText('referenceNo')} style={{width: 500}} />
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={this.submit.bind(this)}>Submit</Button>
          <Button color="primary" onClick={ () => { this.setState({ dialogOpen: false }) } }>Close</Button>
        </DialogActions>
      </Dialog>

      <Dialog fullWidth={this.state.fullWidth}  maxWidth={this.state.maxWidth}
        open={this.state.remarkDialog} onClose={ () => { this.setState({ remarkDialog: false }) } } aria-labelledby="max-width-dialog-title">
        <DialogTitle id="max-width-dialog-title" style={{width: 400}}>Remarks</DialogTitle>
        <DialogContent>{this.state.remarks}</DialogContent>
        <DialogActions>
          <Button color="primary" onClick={ () => { this.setState({ remarkDialog: false }) } }>Close</Button>
        </DialogActions>
      </Dialog>
      </div>
    );
  }
}

export default Title;
